import { ChartData, ChartOptions } from 'chart.js';
import { Bar } from 'react-chartjs-2';

import '../../../components/charts/register';
import { Constants } from '../../../../../../../constants/redeProto';
import { protoColors } from '../../../theme/tokens';
import { AgingBucketCount } from '../utils';

/** Faixas em ordem crescente de espera: quanto mais tempo, mais grave. */
const BUCKET_COLORS = [
  protoColors.success,
  protoColors.lime,
  protoColors.warning,
  protoColors.danger,
];

interface AgingChartProps {
  buckets: AgingBucketCount[];
  height?: number;
}

export function AgingChart({
  buckets,
  height = 260,
}: AgingChartProps): JSX.Element {
  const chartData: ChartData<'bar'> = {
    labels: buckets.map((bucket) => bucket.label),
    datasets: [
      {
        label: Constants.inAccreditation.aging.axisLabel,
        data: buckets.map((bucket) => bucket.count),
        backgroundColor: buckets.map(
          (_, index) => BUCKET_COLORS[index] ?? protoColors.purple
        ),
        borderRadius: 6,
      },
    ],
  };

  const options: ChartOptions<'bar'> = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: { legend: { display: false } },
    scales: {
      y: {
        beginAtZero: true,
        grid: { color: '#EEEEF2' },
        ticks: { precision: 0 },
      },
      x: { grid: { display: false } },
    },
  };

  return (
    <div style={{ height }}>
      <Bar data={chartData} options={options} />
    </div>
  );
}
